export const TAG = 'VideoHighlights';
